export default "__VITE_ASSET__CbvFT5Eg__"